import { useState } from "react";

// Lazy image with skeleton shimmer + blur-up reveal.
export const LazyImage = ({ src, alt = "", className = "", imgClassName = "", ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden bg-slate-200 ${className}`}>
      {!loaded && (
        <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-slate-200 via-slate-100 to-slate-300" />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`h-full w-full object-cover transition-all duration-[900ms] ease-out ${
          loaded ? "scale-100 blur-0 opacity-100" : "scale-105 blur-md opacity-0"
        } ${imgClassName}`}
        {...rest}
      />
    </div>
  );
};
